var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: !_vm.dataForm.id ? "新增" : "编辑",
        "close-on-click-modal": false,
        visible: _vm.visible,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        close: _vm.handleDialogClose,
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: {
            model: _vm.dataForm,
            rules: _vm.dataRule,
            "label-width": "180px",
          },
          nativeOn: {
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.dataSubmit()
            },
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "消息类型(0=订阅,1=微信模板)", prop: "type" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入类型", disabled: _vm.isEdit },
                model: {
                  value: _vm.dataForm.type,
                  callback: function ($$v) {
                    _vm.$set(_vm.dataForm, "type", $$v)
                  },
                  expression: "dataForm.type",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "模板名", prop: "name" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入模板名", disabled: _vm.isEdit },
                model: {
                  value: _vm.dataForm.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.dataForm, "name", $$v)
                  },
                  expression: "dataForm.name",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "关键词", prop: "content" } },
            [
              _c("el-input", {
                attrs: {
                  placeholder: "请输入关键词",
                  disabled: _vm.isEdit,
                  type: "textarea",
                  rows: "5",
                },
                model: {
                  value: _vm.dataForm.content,
                  callback: function ($$v) {
                    _vm.$set(_vm.dataForm, "content", $$v)
                  },
                  expression: "dataForm.content",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "模板ID", prop: "freightTemplateId" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入模板ID", disabled: _vm.isEdit },
                model: {
                  value: _vm.dataForm.freightTemplateId,
                  callback: function ($$v) {
                    _vm.$set(_vm.dataForm, "freightTemplateId", $$v)
                  },
                  expression: "dataForm.freightTemplateId",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "状态", prop: "status" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入状态", disabled: _vm.isEdit },
                model: {
                  value: _vm.dataForm.status,
                  callback: function ($$v) {
                    _vm.$set(_vm.dataForm, "status", $$v)
                  },
                  expression: "dataForm.status",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "模板标识", prop: "mark", required: "" } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择模板标识", clearable: "" },
                  model: {
                    value: _vm.dataForm.mark,
                    callback: function ($$v) {
                      _vm.$set(_vm.dataForm, "mark", $$v)
                    },
                    expression: "dataForm.mark",
                  },
                },
                [
                  _c("el-option", {
                    attrs: { label: "支付成功", value: "paySuccess" },
                  }),
                  _vm._v(" "),
                  _c("el-option", {
                    attrs: { label: "发货通知", value: "deliver" },
                  }),
                  _vm._v(" "),
                  _c("el-option", {
                    attrs: { label: "配送通知", value: "fulfillment" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm._l(_vm.getMarkFields(), function (field, index) {
            return _c(
              "el-form-item",
              { key: index, attrs: { label: field.label + "：" } },
              [
                _c(
                  "el-select",
                  {
                    staticStyle: { width: "350px" },
                    attrs: { placeholder: "请选择对应模板字段" },
                    model: {
                      value: _vm.mappingData[field.key],
                      callback: function ($$v) {
                        _vm.$set(_vm.mappingData, field.key, $$v)
                      },
                      expression: "mappingData[field.key]",
                    },
                  },
                  _vm._l(_vm.contentFieldList, function (item) {
                    return _c("el-option", {
                      key: item.field,
                      attrs: {
                        label: item.comment
                          ? item.field + " (" + item.comment + ")"
                          : item.field,
                        value: item.field,
                      },
                    })
                  }),
                  1
                ),
                _vm._v(" "),
                _vm.contentFieldList.length === 0
                  ? _c(
                      "span",
                      {
                        staticStyle: {
                          color: "#f56c6c",
                          "font-size": "12px",
                          "margin-left": "10px",
                        },
                      },
                      [
                        _vm._v(
                          "\n        未解析到模板字段，请检查回复内容格式\n      "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.mappingData[field.key] && _vm.isSubmitCheck
                  ? _c(
                      "span",
                      {
                        staticStyle: {
                          color: "#f56c6c",
                          "font-size": "12px",
                          "margin-left": "10px",
                        },
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(field.label) +
                            "为必填项\n      "
                        ),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            )
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v("取消")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.isLoading },
              on: {
                click: function ($event) {
                  return _vm.dataSubmit()
                },
              },
            },
            [_vm._v("确认")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }